import DefaultLayout from './components/layouts/default';
import SideTabs from './components/sideTab';
import Home from './pages/home';
import Backgrounds from './pages/background';
import Windows from './pages/windows';
import NumberPlate from './pages/numberPlate';
import Result from './pages/result';
import './Globle.css';
import './customGloble.css';
import Login from './pages/login/Login';
import { useSelector } from 'react-redux';
import React from 'react';

function App() {
  const {isLogin, dimension} = useSelector(state => state.carromm);
  let contents = (dimension !== "") ? (dimension === "2D" ? [Home, Backgrounds, Windows, NumberPlate, Result] : [Home, Windows, NumberPlate, Result]) : [];
  console.log("App dimension", dimension, contents);

  return (
    <DefaultLayout>
      {
        isLogin ?
          <SideTabs contents={contents} /> :
          <Login />
      }

    </DefaultLayout>
  );
}

export default App;
